var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 1399 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1052.31 18.34H1043V46.21H1037.57V18.34H1028.22V13.14H1052.31V18.34Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1085.28 39.55H1071.2L1068.89 46.21H1062.98L1074.98 13.14H1081.5L1093.45 46.21H1087.59L1085.28 39.55ZM1083.49 34.45L1078.25 19.52L1073 34.45H1083.49Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1127.99 41.01V46.21H1109.09V13.14H1114.52V41.01H1127.99Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1164.17 41.01V46.21H1144.09V13.14H1163.93V18.34H1149.52V26.94H1162.75V32.09H1149.52V41.02H1164.17V41.01Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1206.5 13.14V46.21H1202.25L1186.66 23.77V46.21H1181.23V13.14H1185.48L1201.07 35.58V13.14H1206.5Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1246.7 18.34H1237.39V46.21H1231.96V18.34H1222.61V13.14H1246.7V18.34Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1050.04 94.76H1035.96L1033.65 101.42H1027.74L1039.74 68.35H1046.26L1058.21 101.42H1052.35L1050.04 94.76ZM1048.25 89.66L1043 74.73L1037.76 89.66H1048.25Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1070.97 84.89C1070.97 75.3 1078.2 67.74 1088.26 67.74C1094.31 67.74 1099.69 70.81 1102.48 75.63L1097.76 78.37C1096.01 75.11 1092.42 73.03 1088.26 73.03C1081.13 73.03 1076.4 78.09 1076.4 84.89C1076.4 91.69 1081.12 96.75 1088.26 96.75C1092.42 96.75 1096.05 94.67 1097.76 91.41L1102.48 94.1C1099.74 98.92 1094.36 102.04 1088.26 102.04C1078.2 102.04 1070.97 94.48 1070.97 84.89Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1140.32 73.55H1131.01V101.42H1125.58V73.55H1116.23V68.35H1140.32V73.55Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1161.86 68.35V101.42H1156.43V68.35H1161.86Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1177.49 68.35H1183.44L1192.23 94.85L1201.06 68.35H1206.97L1195.49 101.42H1188.97L1177.49 68.35Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1239.94 94.76H1225.86L1223.55 101.42H1217.64L1229.64 68.35H1236.16L1248.11 101.42H1242.25L1239.94 94.76ZM1238.15 89.66L1232.91 74.73L1227.67 89.66H1238.15Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1282.88 73.55H1273.57V101.42H1268.14V73.55H1258.79V68.35H1282.88V73.55Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1304.42 68.35V101.42H1298.99V68.35H1304.42Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1321.47 84.89C1321.47 75.3 1329.08 67.74 1338.62 67.74C1348.21 67.74 1355.77 75.3 1355.77 84.89C1355.77 94.48 1348.21 102.04 1338.62 102.04C1329.08 102.04 1321.47 94.48 1321.47 84.89ZM1350.34 84.89C1350.34 78.09 1345.24 73.03 1338.62 73.03C1332.01 73.03 1326.9 78.09 1326.9 84.89C1326.9 91.69 1332 96.75 1338.62 96.75C1345.24 96.74 1350.34 91.69 1350.34 84.89Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1398.1 68.35V101.42H1393.85L1378.26 78.98V101.42H1372.83V68.35H1377.08L1392.67 90.79V68.35H1398.1Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1053.96 134.43C1053.96 140.52 1049.24 145.3 1043 145.3H1036.24V156.64H1030.81V123.57H1043C1049.24 123.56 1053.96 128.29 1053.96 134.43ZM1048.53 134.43C1048.53 131.08 1046.21 128.67 1043 128.67H1036.24V140.2H1043C1046.22 140.19 1048.53 137.73 1048.53 134.43Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1089.68 151.43V156.63H1070.78V123.56H1076.21V151.43H1089.68Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1125.96 149.97H1111.88L1109.57 156.63H1103.66L1115.66 123.56H1122.18L1134.13 156.63H1128.27L1125.96 149.97ZM1124.16 144.87L1118.92 129.94L1113.68 144.87H1124.16Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1168.89 128.76H1159.58V156.63H1154.15V128.76H1144.8V123.56H1168.89V128.76Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1190.43 128.76V138.02H1203.89V143.22H1190.43V156.64H1185V123.57H1204.37V128.77H1190.43V128.76Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1219.91 140.1C1219.91 130.51 1227.52 122.95 1237.06 122.95C1246.65 122.95 1254.21 130.51 1254.21 140.1C1254.21 149.69 1246.65 157.25 1237.06 157.25C1227.52 157.25 1219.91 149.69 1219.91 140.1ZM1248.77 140.1C1248.77 133.3 1243.67 128.24 1237.05 128.24C1230.44 128.24 1225.33 133.29 1225.33 140.1C1225.33 146.91 1230.43 151.96 1237.05 151.96C1243.67 151.95 1248.77 146.9 1248.77 140.1Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1283.12 144.58H1276.7V156.63H1271.27V123.56H1284.5C1290.41 123.56 1295.13 128.28 1295.13 134.19C1295.13 138.44 1292.44 142.22 1288.56 143.78L1296.07 156.63H1290.12L1283.12 144.58ZM1276.69 139.72H1284.48C1287.36 139.72 1289.68 137.26 1289.68 134.19C1289.68 131.07 1287.37 128.66 1284.48 128.66H1276.69V139.72Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M1338.53 156.63V133.06L1328.47 149.69H1327.81L1317.75 133.01V156.63H1312.32V123.56H1318.18L1328.15 140.09L1338.16 123.56H1343.97V156.63H1338.53Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M248.96 3.05H227.18V166.95H319.67V146.35H248.96V3.05Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M486.84 3.05H462.27L401.16 166.95H424.33L474.54 28.91L524.78 166.95H547.96L486.84 3.05Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M739.72 105.11C738.77 102.77 737.26 100.47 735.15 98.18C733.04 95.92 731.21 94.01 729.66 92.43C728.11 90.88 725.72 89.24 722.52 87.51C719.33 85.8 716.79 84.46 714.92 83.51C713.04 82.59 710.12 81.41 706.13 79.99C702.14 78.6 699.18 77.53 697.28 76.86C695.35 76.17 692.18 75.05 687.76 73.48C675.11 69.42 666.19 65.53 661.04 61.79C655.9 58.05 653.32 52.58 653.32 45.4C653.32 37.92 656.03 32 661.51 27.61C666.98 23.24 674.16 21.06 683.05 21.06C700.84 21.06 713.25 29.5 720.28 46.36L738.54 35.82C733.7 25.05 726.49 16.38 716.89 9.82C707.29 3.29 696.01 0 683.05 0C668.68 0 656.51 4.19 646.53 12.54C636.53 20.9 631.54 32.18 631.54 46.38C631.54 52.3 632.6 57.62 634.71 62.3C636.81 66.98 639.2 70.76 641.86 73.66C644.49 76.55 648.53 79.36 653.92 82.08C659.3 84.82 663.8 86.8 667.42 88.06C671.04 89.3 676.25 91.09 683.06 93.43C696.95 97.8 706.87 101.93 712.79 105.85C718.73 109.75 721.71 115.61 721.71 123.43C721.71 131.06 718.74 137.2 712.79 141.8C706.87 146.41 698.29 148.71 687.04 148.71C664.25 148.71 649.65 138.8 643.26 118.99L624.53 129.75C628.9 142.25 636.51 152.08 647.36 159.27C658.2 166.4 671.26 170 686.57 170C703.41 170 717.07 165.75 727.53 157.23C737.98 148.73 743.22 137.3 743.22 122.93C743.22 119.49 742.89 116.24 742.18 113.19C741.46 110.15 740.63 107.45 739.72 105.11Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M820.48 3.05V23.66H868.73V166.95H890.27V23.66H938.73V3.05H820.48Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M66.37 139.72L31.31 39.06H8.25L53.93 166.95H78.51L137.28 3.05H113.63L66.37 139.72Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.02 25.09C17.1062 25.09 22.04 20.1562 22.04 14.07C22.04 7.98382 17.1062 3.05 11.02 3.05C4.93382 3.05 0 7.98382 0 14.07C0 20.1562 4.93382 25.09 11.02 25.09Z",
          fill: _vm.fill,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }